export default {
  choose_subject: "Choose a subject",
  show_lesson: "View lessons",
  course: "Lessons",
  lessonLink: "Link",
  activityDone: "Activities done",
  workToDo: "Work to be prepared",
  generalCourses: "General lessons",
  attachments: "Attachments",
  attachment: "Attachment",
  download: "Download",
  "Taught subject": "Taught subject",
  lesson_info:
    "This menu allows you to configure the subjects linked to different modules: calendar, skills, report card",
  lesson_search_label: "Search for a lesson or a subject",
  lesson_search_placeholder: "Keywords: lesson, subject...",
  lesson_search_reset: "Clear search",
  lesson_search_no_result: "No lesson matches your search",
  lessons_count: ({ plural }) => plural(["lesson", "lessons"]),
  lesson_search_results_count: ({ plural, named }) =>
    plural([`${named("count")} lesson found`, `${named("count")} lessons found`]),
};
